import { TenantActions, TenantActionTypes } from './tenant.actions';

import { TenantState, TENANT_INITIAL_STATE } from './tenant.state';

export function tenantReducer(
  state: TenantState = TENANT_INITIAL_STATE,
  action: TenantActions,
): TenantState {
  switch (action.type) {
    case TenantActionTypes.INITIALISE: {
      return { ...state, tenant: action.payload };
    }

    default: {
      return state;
    }
  }
}
